import script from "./australiaPromo.vue?vue&type=script&lang=ts&setup=true"
export * from "./australiaPromo.vue?vue&type=script&lang=ts&setup=true"

import "./australiaPromo.vue?vue&type=style&index=0&id=18196a92&lang=scss"

const __exports__ = script;

export default __exports__